import { Component, Input, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-feather-icons',
  templateUrl: './feather-icons.component.html',
  styleUrls: ['./feather-icons.component.scss'],
})
export class FeatherIconsComponent implements OnChanges, AfterViewInit {
  @Input('icon') public icon: string;

  ngAfterViewInit(): void {
    this.renderIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icon'] && !changes['icon'].firstChange) {
      this.renderIcon();
    }
  }

  private renderIcon(): void {
    setTimeout(() => feather.replace());
  }
}
